import { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { api } from '../services/api';

const DEFAULT_FR = 'Loranrix — Portfolio développeur full-stack';
const DEFAULT_EN = 'Loranrix — Full-stack developer portfolio';

/**
 * Met à jour document.title depuis site_data (modifiable dans l’admin).
 */
export default function SiteDocumentTitle() {
  const { language } = useLanguage();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.getSiteData();
        if (cancelled) return;
        const meta = data.siteMeta || {};
        const title =
          language === 'fr'
            ? meta.documentTitleFr || DEFAULT_FR
            : meta.documentTitleEn || DEFAULT_EN;
        document.title = title;
      } catch {
        if (!cancelled) {
          document.title = language === 'fr' ? DEFAULT_FR : DEFAULT_EN;
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [language]);

  return null;
}
